/** @jsxImportSource @gasman/smush */

import './pattern_editor.css';

import { ContainerComponent } from '@gasman/smush';

import { PatternEditorState } from '../views/pattern_editor_state';
import { PatternTable } from './pattern_table';
import { Counter } from '../widgets/counter';

class PatternEditorStatusBar extends ContainerComponent {
    constructor(app, engine) {
        super();
        this.editorState = null;
        this.app = app;

        this.patternSelector = Counter.forField(
            PatternEditorState.fields.patternNumber,
        );
        this.patternLengthSelector = Counter.forField(
            engine.Pattern.fields.length,
        );
        this.octaveSelector = Counter.forField(
            PatternEditorState.fields.octave,
        );
        this.sampleSelector = Counter.forField(
            PatternEditorState.fields.sampleNumber,
        );

        this.playButton = <button>Play pattern</button>;
        this.playButton.addEventListener('click', () => {
            if (this.app.player.isPlaying) {
                this.app.player.stop();
            } else if (!this.app.player.isActive) {
                this.app.player.playPattern(this.editorState.patternNumber);
            }
        });
        this.app.player.on('startPlaying', () => {
            this.playButton.innerText = 'Stop';
        });
        this.app.player.on('stopPlaying', () => {
            this.playButton.innerText = 'Play pattern';
        });

        this.components = [
            this.patternSelector,
            this.patternLengthSelector,
            this.octaveSelector,
            this.sampleSelector,
        ];
    }

    render(container) {
        container.appendChild(
            <div class="pattern-editor-status">
                {this.patternSelector}
                {this.patternLengthSelector}
                {this.octaveSelector}
                {this.sampleSelector}
                {this.playButton}
            </div>,
        );
    }

    bindSong() {}
    unbindSong() {}
    bindPattern(pattern, opts) {
        this.patternLengthSelector.bind(pattern, opts);
    }
    unbindPattern() {
        this.patternLengthSelector.unbind();
    }
    bindState(editorState) {
        this.editorState = editorState;
        this.patternSelector.bind(editorState);
        this.octaveSelector.bind(editorState);
        this.sampleSelector.bind(editorState);
    }
    unbindState() {
        this.patternSelector.unbind();
        this.octaveSelector.unbind();
        this.sampleSelector.unbind();
        this.editorState = null;
    }
}

class PatternEditor extends ContainerComponent {
    constructor(app, engine) {
        super();
        this.state = null;
        this.song = null;
        this.statusBar = new PatternEditorStatusBar(app, engine);
        this.patternTable = new PatternTable(app, engine.Pattern);

        this.components = [this.statusBar, this.patternTable];

        app.player.on('startPlaying', () => {
            if (this.state) {
                this.state.isFollowingPlayback = true;
            }
        });
        app.player.on('playPattern', (patternNumber) => {
            if (this.state && this.state.isFollowingPlayback) {
                this.state.patternNumber = patternNumber;
            }
        });
        app.player.on('stopPlaying', () => {
            if (this.state) {
                this.state.isFollowingPlayback = false;
            }
        });
    }

    render(container) {
        this.statusBar.render(container);
        let patternEditorContainer = <div class="pattern-editor"></div>;
        container.appendChild(patternEditorContainer);
        this.patternTable.render(patternEditorContainer);
    }

    selectPattern = (patternNumber) => {
        let opts = {
            undoBuffer: this.song.undoBuffer,
            undoPath: ['patterns', patternNumber],
        };

        let pattern = this.song.getPattern(patternNumber);
        this.patternTable.bindPattern(pattern, opts);
        this.statusBar.bindPattern(pattern, opts);
    };

    bindSong(song, opts) {
        this.song = song;
        this.statusBar.bindSong(song, opts);
        if (this.state) this.selectPattern(this.state.patternNumber);
    }
    unbindSong() {
        this.statusBar.unbindPattern();
        this.patternTable.unbindPattern();
        this.statusBar.unbindSong();
        this.song = null;
    }
    bindState(state) {
        this.state = state;
        this.state.on('changePatternNumber', this.selectPattern);
        this.statusBar.bindState(this.state);
        this.patternTable.bindState(this.state);
        if (this.song) this.selectPattern(this.state.patternNumber);
    }
    unbindState() {
        this.patternTable.unbindState();
        this.statusBar.unbindState();
        this.state.removeListener('changePatternNumber', this.selectPattern);
        this.state = null;
    }

    focus() {
        this.patternTable.focus();
    }
}

export { PatternEditor };
